export type PriceValueFormat = 'bid' | 'bidStep';

/** Тип сделки для строки прайса (продажа / аренда). */
export enum PriceDealType {
  Sale = 'sale',
  Rent = 'rent',
}

export interface IPriceRow {
  /**
   * Тип сделки. Если поле отсутствует, на фронте обрабатывается как продажа (обратная совместимость).
   * В новых данных для конфига поле рекомендуется задавать явно.
   */
  type?: PriceDealType;
  name: string;
  bidPerView: number;
  minDailyLimit: number;
  bidStep: number;
  /** Формат для колонки «Ставка за просмотр». */
  bidPerViewFormat: PriceValueFormat;
  /** Формат для колонки «Мин. дневной лимит». */
  minDailyLimitFormat: PriceValueFormat;
  /** Формат для колонки «Шаг ставки». */
  bidStepFormat: PriceValueFormat;
}

export interface IPriceCategory {
  categoryName: string;
  rows: IPriceRow[];
}

export type RegionId = 'msk' | 'spb' | 'ekb' | 'kazan' | 'novosibirsk' | 'samara' | 'ufa' | 'rostov-on-don';
